/**
 * CategoryList
 */
import React, { useState } from 'react';
import { Transition } from 'react-transition-group';
import { useUuid } from 'ui-component-library/hooks';
import Text from 'ui-component-library/base/Text';
import clsx from 'clsx';
import { Icon } from 'ui-component-library/base';
/** Main description for this component. */
var CategoryList = function (_a) {
    var header = _a.header, _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.headingLevel, headingLevel = _c === void 0 ? 'h2' : _c, openCategoryLabel = _a.openCategoryLabel, closeCategoryLabel = _a.closeCategoryLabel, className = _a.className, children = _a.children;
    var getUuid = useUuid()[0];
    var id = getUuid();
    var _d = useState(open), expanded = _d[0], setExpanded = _d[1];
    return (React.createElement("div", { className: className, "data-cid": "CategoryList" },
        React.createElement(Text, { as: headingLevel, styleAs: "h4", margin: false, className: "mb-4" },
            React.createElement("button", { className: clsx('flex', 'w-full', 'bg-white'), "aria-expanded": expanded, "aria-controls": "accordion-item-content-" + id, id: "accordion-item-button-" + id, onClick: function () {
                    setExpanded(!expanded);
                } },
                React.createElement(Icon, { icon: expanded ? 'minus' : 'plus', "aria-hidden": "true", className: clsx(expanded ? 'mr-4' : 'mr-5 pl-1', 'text-purple'), size: 2 }),
                React.createElement("span", { className: "sr-only" }, expanded ? closeCategoryLabel : openCategoryLabel),
                React.createElement("span", { className: "font-bold text-left" }, header))),
        React.createElement(Transition, { in: expanded, timeout: 200 }, function (state) { return (React.createElement("div", { id: "accordion-item-content-" + id, role: "region", "aria-labelledby": "accordion-item-button-" + id, hidden: state === 'exited', className: clsx(state === 'exiting' ? 'animate-fade-out' : 'animate-fade-in') },
            React.createElement("ul", { className: "pl-10" }, children))); })));
};
export default CategoryList;
